import React from 'react'

// Types
import { NavigationState } from '../types'

export const initialState: NavigationState = {
  index: 0,
  history: [],
  routes: {},
  actions: {
    navigate: () => {},
    back: () => {},
    forward: () => {},
  }
}

const NavigationContext = React.createContext(initialState)

export default NavigationContext
